import { combineReducers } from 'redux';
import snack from "./snack";

export default combineReducers({snack})
